<template>
  <div class="amp_main">
    <div class="wate_con" v-loading="loading">
      <div class="flex_bet_h tools_titmod">
        <span class="tools_tit">短视频去水印 </span>
        <img src="../../assets/images/img2/offlogin.png" class="tools_off" @click="hide" />
      </div>
      <textarea class="wate_inp" placeholder="请粘贴短视频分享链接" v-model="url"></textarea>
      <!-- <img src="../../assets/images/img2/wateprompt.png" class="wate_prompt" /> -->
      <div class="wate_prompt_text">
        <p class="tishi-t1">温馨提示</p>
        <p class="tishi-t3">1. 在短视频平台点击分享按钮，选择复制链接</p>
        <p class="tishi-t3">2. 将视频链接粘贴到输入框中，点击去水印即可解析出无水印视频</p>
        <p class="tishi-t3">3. 支持抖音、快手、剪映、Tiktok、微博、QQ看点视频、西瓜视频、今日头条、趣头条、火锅视频、美拍、快影、微视、火山小视频、皮皮虾、好看视频、绿洲、VUE、秒拍、梨视频、刷宝、全民小视频、陌陌视频、UC浏览器、Twitter、轻视频、Bilibili、茄子短视频、灵感、WIDE、开眼、全民K歌、最右、小咖秀、皮皮搞笑、AcFun、网易云音乐、咪咕圈圈、Keep、梨涡、小影、新片场、场库、阳光宽频网、比心、逗拍等超过50个平台的短视频去水印解析</p>
        <p class="tishi-t3">4. 如果视频大小较大，建议在结果页面选择复制链接，然后粘贴到浏览器下载，避免出现错误</p>
        <p class="tishi-t3">注：B站和好看视频仅支持解析下载，不支持去水印 </p>
      </div>
      <div class="wate_btn" @click="qryApiLimit">解析并下载</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: "", //短视频分享链接
      loading: false, //加载动画显示状态
    };
  },
  methods: {
    // 查询接口调用次数
    qryApiLimit() {
      this.$globalFun.qryApiLimit(this, '0', () => {
        this.startWatermark()
      })
    },
    // 更新api使用剩余次数
    uptApiLimit: function () {
      this.$globalFun.uptApiLimit(this, '0')
    },
    // 去水印解析
    startWatermark() {
      let self = this;
      if (this.url == "") {
        this.$message({
          message: "短视频分享链接不能为空",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      // 这个接口不加解密
      let url = self.$store.state.app_api + self.$store.state.app_url.watermark;
      let json = {
        req: JSON.stringify({
          qd: self.$store.state.qd, //渠道号
          ver: self.$store.state.ver, //版本号
          mp4url: this.url,
          ismini: "0",
        }),
      };
      var data = this.$Qs.stringify(json);
      this.$http
        .post(url, data)
        .then((response) => {
          console.log(1, response)
          self.loading = false;
          if (response.data.rc !== '0') {
            this.$message({
              message: "解析失败！",
              type: "warning",
            });
            return
          }
          this.$globalFun.uptApiLimit(this, '0')
          let video_url = response.data.model.body.video_url;
          window.location.href = video_url;
        })
        .catch((error) => {
          self.loading = false;
          this.$message({
            message: "解析失败！",
            type: "warning",
          });
        });
    },
    // 关闭点击
    hide() {
      this.$emit("hide");
    },
  },
};
</script>

<style scoped>
@import url("../../assets/css/tools.css");
</style>



// WEBPACK FOOTER //
// src/components/tools/watermark.vue